module.exports = __webpack_public_path__ + "static/media/img1-4.b233d7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/biosense/diff/img1-4.png
// module id = 1523
// module chunks = 3